class MetaobjectColorCards {
  constructor(section) {
    this.section = section;
    this.cards = section.querySelectorAll('.metaobject-card');
    this.isDynamicMode = section.dataset.dynamicMode === 'true';
    this.assembleTargetId = section.dataset.assembleTargetId;

    if (this.isDynamicMode) {
      this.init();
    }
  }

  init() {
    this.cards.forEach((card, index) => {
      card.addEventListener('click', (e) => this.handleCardClick(e, card));
      card.style.cursor = 'pointer';
    });

    // Shopify Liquid only resolves nested metaobject references for the first
    // few list entries, so cards beyond that point are rendered without a
    // data-collection-handle. Backfill the missing handles via the Storefront API.
    this.hydrateCollectionHandles();
  }

  async hydrateCollectionHandles() {
    const missing = Array.from(this.cards).some(card => !card.dataset.collectionHandle);
    if (!missing) {
      return;
    }

    const pageHandle = this.section.dataset.pageHandle;
    const token = window.themeSettings && window.themeSettings.storefront_api_token;
    const shop = window.Shopify && window.Shopify.shop;

    if (!pageHandle || !token || !shop) {
      console.error('❌ [MetaobjectColorCards] Cannot hydrate handles — missing requirements', {
        pageHandle,
        hasToken: !!token,
        shop
      });
      return;
    }

    const query = `
      query getColorCards($handle: String!) {
        page(handle: $handle) {
          metafield(namespace: "custom", key: "cores_monte_seu_conjunto") {
            references(first: 50) {
              nodes {
                ... on Metaobject {
                  field(key: "colecao-2") {
                    reference {
                      ... on Collection {
                        handle
                        title
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;

    try {
      const response = await fetch(`https://${shop}/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({ query, variables: { handle: pageHandle } })
      });

      const result = await response.json();
      if (result.errors) {
        console.error('❌ [MetaobjectColorCards] GraphQL errors while hydrating handles:', JSON.stringify(result.errors, null, 2));
        return;
      }

      const nodes = result?.data?.page?.metafield?.references?.nodes || [];

      nodes.forEach((node, index) => {
        const collection = node && node.field && node.field.reference;
        if (!collection || !collection.handle) {
          console.warn(`⚠️ [MetaobjectColorCards] Node ${index + 1} collection reference unavailable — check that the collection is published to the Online Store sales channel`);
          return;
        }

        const card = this.section.querySelector(`.metaobject-card[data-card-index="${index + 1}"]`);
        if (card && !card.dataset.collectionHandle) {
          card.dataset.collectionHandle = collection.handle;
          card.dataset.collectionTitle = collection.title || '';
        }
      });
    } catch (error) {
      console.error('❌ [MetaobjectColorCards] Error hydrating collection handles:', error);
    }
  }

  handleCardClick(e, card) {
    e.preventDefault();
    
    const collectionHandle = card.dataset.collectionHandle;
    const collectionTitle = card.dataset.collectionTitle;

    if (!collectionHandle) {
      console.error('❌ [MetaobjectColorCards] No collection handle found on card', card);
      return;
    }

    this.setActiveCard(card);
    this.updateAssembleYourSet(collectionHandle, collectionTitle);
  }

  setActiveCard(activeCard) {
    this.cards.forEach(card => {
      card.classList.remove('metaobject-card--active');
    });
    activeCard.classList.add('metaobject-card--active');
  }

  updateAssembleYourSet(collectionHandle, collectionTitle) {
    const event = new CustomEvent('metaobject-color-selected', {
      detail: {
        collectionHandle,
        collectionTitle,
        timestamp: Date.now()
      },
      bubbles: true
    });

    document.dispatchEvent(event);

    const assembleSection = this.findAssembleSection();

    if (assembleSection && typeof assembleSection.loadCollectionProducts === 'function') {
      assembleSection.loadCollectionProducts(collectionHandle, collectionTitle);
    } else {
      console.error('❌ [MetaobjectColorCards] Assemble section not found or loadCollectionProducts method missing', {
        assembleSection,
        hasMethod: assembleSection ? typeof assembleSection.loadCollectionProducts : 'N/A'
      });
    }
  }

  findAssembleSection() {
    // If target ID is specified, use it
    if (this.assembleTargetId) {
      const targetSection = document.getElementById(this.assembleTargetId);
      if (targetSection) {
        return targetSection.querySelector('assembler-element-dynamic, assembler-element');
      }
    }

    // Otherwise, search for dynamic version first, then fallback to regular
    return document.querySelector('assembler-element-dynamic') || document.querySelector('assembler-element');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-dynamic-mode="true"]');
  sections.forEach(section => {
    new MetaobjectColorCards(section);
  });
});
